import Pino from "pino";
const logger = Pino({
  level: process.env.LOG_LEVEL || "info",
  // use LOG_LEVEL=silent to disable logging during tests
  formatters: {
    level(label) {
      return { severity: label.toUpperCase() };
    }
  },
  timestamp: Pino.stdTimeFunctions.isoTime
});
export {
  logger
};
